import { useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router'
import { useAuth } from '@app/contexts/auth'

export const ShareRedirectHandler = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { authData } = useAuth()

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search)
    const username = searchParams.get('username')

    if (username && !authData?.authenticated && location.pathname.startsWith('/shared/')) {
      const shareId = location.pathname.split('/shared/')[1]
      if (username && shareId) {
        navigate(`/share-login?username=${username}&share=${shareId}`, { replace: true })
      }
    }
    // If user is authenticated and on /shared/:id, redirect to /share/:id
    else if (authData?.authenticated && location.pathname.startsWith('/shared/')) {
      const shareId = location.pathname.split('/shared/')[1]
      if (shareId) {
        navigate(`/share/${shareId}`, { replace: true })
      }
    }
  }, [authData?.authenticated, location, navigate])

  return null
}
